// react
import React from 'react';

// router
import { Outlet } from 'react-router-dom';

// mui
import { Box } from '@mui/material';

// Component

export const WorkPlanning: React.FC = () => {
	return (
		<Box sx={{ width: '100%' }}>
			<Outlet />
		</Box>
	);
};

export default WorkPlanning;
